import config from 'crm/config'

const oemCustomer = `${config.apiHost}/oem-customer`

export default {
    contactWayMaterialsExport: {
        url: `${oemCustomer}/api/oem_miniso/contact_way_materials/export`,
        type: 'POST',
    },
    updateContactWayMaterialsSettings: {
        url: `${oemCustomer}/api/oem_miniso/contact_way_materials/settings`,
        type: 'PUT',
    },
    contactWayMaterialsSettings: {
        url: `${oemCustomer}/api/oem_miniso/contact_way_materials/settings`,
        type: 'GET',
    },
}
